export * from './simple-layout.component';



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/containers/simple-layout/index.ts